export default "__VITE_ASSET__DaHVNnSI__"